import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSuccessStyle0 = cosmosIconCss;

const CosmosIconSuccess$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSuccess extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'd1623201147e080e6097bd3666bc3e3f97c63f3d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '835c225769dbd420c4a14a552895edd72ae7311e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1b04ea2d7c2f3921ba0f6ad6600630ea1937f786', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 18.5a7.5 7.5 0 0 0 7.093-9.944.523.523 0 0 1 .165-.584l.428-.333a.474.474 0 0 1 .741.194 9 9 0 1 1-5.11-5.202c.317.126.388.53.15.774l-.395.408a.522.522 0 0 1-.551.121A7.5 7.5 0 1 0 11 18.5Zm-3.88-7.62L10 13.72a.49.49 0 0 0 .69-.03l8.88-10.55a.49.49 0 0 0-.06-.7l-.38-.32a.51.51 0 0 0-.71.06l-8.17 9.71-2.07-2.07a.51.51 0 0 0-.71 0l-.35.36a.48.48 0 0 0 0 .7Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSuccessStyle0; }
}, [1, "cosmos-icon-success", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-success"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-success":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSuccess$1);
            }
            break;
    } });
}

const CosmosIconSuccess = CosmosIconSuccess$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSuccess, defineCustomElement };
